import { MarkdownDocs } from '@mui/internal-core-docs/MarkdownDocs';
import * as pageProps from 'docs/data/chat/backend/built-in-adapters/echo-adapter/echo-adapter.md?muiMarkdown';

export default function Page() {
  return <MarkdownDocs {...pageProps} />;
}
